import {
  FormTabs,
} from "@wac-ui-dashboard/wac_component_library";
import Style from "./scheduleUpdationForm.module.scss";
import useUpdateSchedule from "./useUpdateSchedule";

const UpdateSchedule = ({ activeId, refetch, isEditData }) => {
  const {
    tabs,
    activeTab,
    handleTabClick,
    handleMoveToErrorTab,
    renderTabContent,
    formik,
  } = useUpdateSchedule({
    activeId,
    refetch,
    isEditData,
  });

  return (
    <>
    <FormTabs
      propStyle={{ root: Style.FormTabs_root }}
      tabs={tabs}
      active={activeTab}
      handleClick={handleTabClick}
    />
    <form onSubmit={(e) => {formik.handleSubmit(e); handleMoveToErrorTab();}}>{renderTabContent()}</form>
    </>
  );
};
export default UpdateSchedule;
